import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const SectionTitle = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Container = styled.div`
  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;
